<template>
	<div id="modal-project-members" class="modal-new hidden">
		<svg @click="onCancel" class="btn-close-modal" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
			<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
			<path d="M0 0h24v24H0z" fill="none" />
		</svg>
		<span class="title">Project Members</span>
		<div class="modal-body-container">
			<div class="project-members-list" v-for="member in assignedMembers" :key="member.id">
				<img class="member-avatar" :src="getGravatar(member.email)" alt="" />
                <div class="member-name">
					<span>{{ name(member) }}</span>
                    <span class="color-warning ml-1" v-if="isUserSuspended(member)">(suspended)</span>
                </div>
			</div>
		</div>
		<div class="buttons-continer">
			<button type="button" class="modal-btn --cancel" @click="onCancel">Close</button>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import AvatarMixins from "@/mixins/Avatar";

export default {
	mixins: [AvatarMixins],
	computed: {
		...mapState("Projects", {
			project: "projectSettings",
		}),
		assignedMembers() {
			if (!this.project.users) return [];
			return this.project.users;
		},
	},
	methods: {
        name(user) {
            let name = user.name;
            if (this.$store.state.User.user.id == user.id) name += " (You)";
            return name;
        },

        isUserSuspended(user) {
            if (this.$store.getters['Organizations/accountByUserId'](user.id)?.suspended_at) return true;
            else if (this.$store.getters['Organizations/memberAccountByUserId'](user.id)?.pivot.suspended_at) return true;
        },

		onCancel() {
			if (!this.$store.state.UI.UILoadedStatus) {
				document.querySelector("#modal-project-members").classList.toggle("hidden");
				document.querySelector("#modal-project-members").classList.toggle("fadeInDownModal");
				document.querySelector("#project-selector-modal").classList.toggle("hidden");
				document.querySelector("#project-selector-modal").classList.toggle("fadeInDownModal");
			} else {
				window.UI.hideModal();
			}
		},
	},
};
</script>

<style lang="scss">
#modal-project-members {
	width: 40%;

	.modal-body-container {
		max-height: 440px;
		min-height: 150px;
		overflow-y: scroll;
		scrollbar-color: #989898 transparent;
		scrollbar-width: thin;
		&::-webkit-scrollbar {
			width: 5px;
		}
		&::-webkit-scrollbar-thumb {
			background-color: #989898;
			border-radius: 50px;
		}
		.list-title {
			display: block;
			margin: 0 0 10px !important;
			font-size: 12px;
		}
	}
	.project-members-list {
		display: flex;
		// justify-content: space-between;
		align-items: center;
		// min-height: 50px;
		padding: 10px;
		&:hover {
			background: #363636;
		}
		.member-avatar {
			border-radius: 50%;
			width: 30px;
			height: 30px;
			border: 1px solid var(--primary);
			background: white;
			margin-right: 10px;
		}

		.group-name {
			margin-right: 20px;
			width: 30%;
		}

		.group-name,
		.member-name {
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			color: var(--font-default-color);
			font-size: 12px;
		}
	}

	.buttons-continer {
		margin-top: 30px;
	}
}

.members-list-tooltip-container {
	background: #282828;
	border-radius: var(--box-rounding);
	padding: 15px 25px;
	&.menuable__content__active {
		opacity: 1 !important;
	}
	.user-container {
		padding: 10px 0;

		.member-avatar {
			border-radius: 50%;
			width: 30px;
			height: 30px;
			border: 1px solid var(--primary);
			background: white;
			margin-right: 10px;
		}

		.group-name {
			margin-right: 10px;
			width: 30%;
		}

		.group-name,
		.member-name {
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			color: var(--font-default-color);
			font-size: 12px;
		}
	}
}
</style>
